import React from 'react';
import { FormattedMessage } from 'react-intl';
import { useSelector } from 'react-redux';
import Heading from '@bibliocommons/heading';
import { sendAnalyticsEvents } from '@bibliocommons/utils-analytics';
import { relatedTitlesEventComposer } from '@bibliocommons/analytics-event-composers';
import { BibSlideContainer } from 'app/components/bibs/shared/BibSlide';
import { selectRelatedTitlesForCurrentBib } from 'app/selectors/bibs/DiscoverySelector';

import './RelatedTitles.scss';

const { composeImageClickEvent } = relatedTitlesEventComposer;

function handleClick(relatedTitle) {
  sendAnalyticsEvents(
    composeImageClickEvent({
      metadataId: relatedTitle.get('metadataId')
    })
  );
}

export default function RelatedTitles() {
  const relatedTitles = useSelector(selectRelatedTitlesForCurrentBib);

  if (relatedTitles.size > 0) {
    return (
      <div className="cp-related-titles">
        <div className="heading">
          <Heading tagName="h3" size="medium" variant>
            <FormattedMessage id="related_titles" />
          </Heading>
        </div>
        <div className="items">
          {relatedTitles.map(relatedTitle => (
            <BibSlideContainer
              key={relatedTitle.get('metadataId')}
              metadataId={relatedTitle.get('metadataId')}
              handleClick={() => handleClick(relatedTitle)}
            />
          ))}
        </div>
      </div>
    );
  }

  return null;
}
